const companyData = {
  companyName: "AediaX Tech Private Limited",
  shortName: "AediaX",
  tagline: "Building AI-Powered Software for Next-Generation Businesses",
  
  about: `AediaX Tech Private Limited is an MCA-registered software development and AI solutions company 
based in Odisha, India. The company focuses on building AI-powered applications, business software, 
automation tools, SaaS platforms, and enterprise solutions for startups, institutions, and enterprises.`,
  
  companyInfo: {
    legalName: "AediaX Tech Private Limited",
    companyType: "Private Limited Company",
    status: "Active",
    incorporationDate: "06 June 2025",
    CIN: "U62011OD2025PTC049519",
    ROC: "ROC Cuttack",
    authorizedCapital: "₹1,00,000",
    paidUpCapital: "₹10,000",
    industry: "Software Development & AI Solutions",
    gstin: "Not Applicable (Under Process)",
    pan: "AAQCA1234K" // Example PAN, update with actual
  },
  
  founders: [
    {
      name: "Amresh Bhuyan",
      role: "Founder & Director",
      email: "amresh@aediax.com",
      linkedin: "https://linkedin.com/in/amresh-bhuyan",
      expertise: "AI/ML, Full Stack Development, Business Strategy"
    },
    {
      name: "Sanat Kumar Bhuyan",
      role: "Director",
      email: "sanat@aediax.com",
      expertise: "Business Operations, Strategic Planning"
    }
  ],
  
  registeredOffice: {
    address: "Plot No. 117, Belpal Badsah, Barsahi",
    city: "Barsahi",
    district: "Mayurbhanj",
    state: "Odisha",
    country: "India",
    pincode: "757026",
    landmark: "Near Belpal Market"
  },
  
  contact: {
    email: "info@aediax.com",
    website: "https://aediax.com",
    phone: "+91 78549 98757",
    support: "support@aediax.com",
    sales: "sales@aediax.com",
    whatsapp: "+91 78549 98757"
  },
  
  socialMedia: {
    linkedin: "https://linkedin.com/company/aediax",
    twitter: "https://twitter.com/aediax",
    github: "https://github.com/aediax",
    instagram: "https://instagram.com/aediax"
  },
  
  services: [
    {
      name: "AI Software Development",
      description: "Custom AI-powered applications using machine learning and deep learning",
      technologies: ["TensorFlow", "PyTorch", "Scikit-learn", "OpenAI", "Gemini AI"]
    },
    {
      name: "Custom Software Development",
      description: "Tailored business software solutions for specific industry needs",
      technologies: ["React", "Node.js", "Python", "Java", ".NET"]
    },
    {
      name: "Mobile App Development",
      description: "Cross-platform and native mobile applications",
      technologies: ["React Native", "Flutter", "iOS Swift", "Android Kotlin"]
    },
    {
      name: "Web Application Development",
      description: "Modern, responsive web applications with cutting-edge technologies",
      technologies: ["React", "Vue.js", "Angular", "Next.js", "Node.js"]
    },
    {
      name: "SaaS Platform Development",
      description: "Scalable Software-as-a-Service platforms with subscription management",
      technologies: ["Firebase", "AWS", "MongoDB", "Stripe", "Razorpay"]
    },
    {
      name: "Cloud Solutions",
      description: "Cloud migration, deployment, and optimization services",
      technologies: ["AWS", "Google Cloud", "Azure", "Firebase"]
    },
    {
      name: "Business Automation Software",
      description: "Automate repetitive tasks and streamline business operations",
      technologies: ["RPA", "Workflow Automation", "Business Intelligence"]
    },
    {
      name: "ERP & Management Software",
      description: "Enterprise resource planning and management systems",
      technologies: ["Custom ERP", "School Management", "Hospital Management"]
    },
    {
      name: "AI Chatbot Development",
      description: "Intelligent conversational AI for customer support and engagement",
      technologies: ["Gemini AI", "OpenAI GPT", "Rasa", "Dialogflow"]
    },
    {
      name: "Machine Learning Solutions",
      description: "Predictive analytics, recommendation systems, and computer vision",
      technologies: ["Computer Vision", "NLP", "Predictive Analytics", "Recommendation Systems"]
    }
  ],
  
  products: [
    {
      name: "AediaX Edge Solution",
      description: "Edge computing platform for real-time AI processing",
      status: "Development",
      features: ["Real-time Processing", "Low Latency", "Edge Deployment"]
    },
    {
      name: "AI Chatbot Systems",
      description: "Customizable AI chatbots for businesses",
      status: "Available",
      features: ["Multi-platform", "Multi-language", "Analytics Dashboard"]
    },
    {
      name: "Meal Management System",
      description: "Food ordering and meal scheduling system",
      status: "Deployed",
      features: ["Meal Booking", "Payment Integration", "Analytics"]
    },
    {
      name: "Signature Verification AI",
      description: "AI-powered signature authentication system",
      status: "Research",
      features: ["Fraud Detection", "Biometric Authentication", "Document Verification"]
    },
    {
      name: "Business Management Software",
      description: "Comprehensive business operations management",
      status: "Available",
      features: ["Inventory", "CRM", "HRM", "Accounting"]
    },
    {
      name: "University Management Systems",
      description: "End-to-end university administration platform",
      status: "Development",
      features: ["Student Management", "Exam System", "Fee Collection", "Library Management"]
    }
  ],
  
  technologies: [
    {
      category: "Frontend",
      stack: ["React", "React Native", "Next.js", "Vue.js", "Angular", "Flutter"]
    },
    {
      category: "Backend",
      stack: ["Node.js", "Python (Django/Flask)", "Java (Spring Boot)", ".NET Core", "PHP (Laravel)"]
    },
    {
      category: "Database",
      stack: ["MongoDB", "PostgreSQL", "MySQL", "Firebase Firestore", "Redis"]
    },
    {
      category: "Cloud & DevOps",
      stack: ["AWS", "Google Cloud", "Firebase", "Docker", "Kubernetes", "CI/CD"]
    },
    {
      category: "AI/ML",
      stack: ["TensorFlow", "PyTorch", "Scikit-learn", "OpenAI", "Gemini AI", "LangChain"]
    },
    {
      category: "Mobile",
      stack: ["React Native", "Flutter", "iOS Swift", "Android Kotlin"]
    }
  ],
  
  mission: `To build intelligent software solutions that help businesses automate operations, reduce cost, and scale faster using Artificial Intelligence.`,
  
  vision: `To become a global AI software company delivering innovative technology solutions that transform businesses and improve lives.`,
  
  values: [
    {
      name: "Innovation",
      description: "Constantly pushing boundaries with cutting-edge technology"
    },
    {
      name: "Technology Excellence",
      description: "Delivering high-quality, scalable, and maintainable code"
    },
    {
      name: "Client Satisfaction",
      description: "Putting clients first and exceeding expectations"
    },
    {
      name: "Automation First",
      description: "Automating repetitive tasks to save time and resources"
    },
    {
      name: "AI-Driven Development",
      description: "Leveraging AI to build smarter solutions"
    }
  ],
  
  clients: [
    {
      type: "Universities",
      description: "Custom university management systems"
    },
    {
      type: "Startups",
      description: "MVP development and scaling support"
    },
    {
      type: "Businesses",
      description: "Business automation and custom software"
    },
    {
      type: "Institutions",
      description: "Educational and training institutions"
    },
    {
      type: "Enterprises",
      description: "Enterprise-grade software solutions"
    }
  ],
  
  faq: [
    {
      question: "What does AediaX Tech Private Limited do?",
      answer: "AediaX develops AI-powered software, mobile apps, and business automation solutions for startups, businesses, and enterprises."
    },
    {
      question: "Where is AediaX located?",
      answer: "AediaX Tech Private Limited is based in Odisha, India, with registered office in Barsahi, Mayurbhanj district."
    },
    {
      question: "Who founded AediaX?",
      answer: "AediaX was founded by Amresh Bhuyan, who serves as Founder & Director, along with Sanat Kumar Bhuyan as Director."
    },
    {
      question: "What services does AediaX provide?",
      answer: "We provide AI development, custom software development, mobile apps, SaaS platforms, cloud solutions, and business automation software."
    },
    {
      question: "Is AediaX a registered company?",
      answer: "Yes, AediaX Tech Private Limited is an MCA-registered company in India with CIN: U62011OD2025PTC049519."
    },
    {
      question: "What technologies does AediaX specialize in?",
      answer: "We specialize in React, Node.js, Python, AI/ML (TensorFlow, PyTorch), Firebase, and modern cloud technologies."
    },
    {
      question: "How can I contact AediaX?",
      answer: "You can email us at info@aediax.com, call +91 78549 98757, or visit our website https://aediax.com"
    },
    {
      question: "Does AediaX provide custom software development?",
      answer: "Yes, we specialize in custom software development tailored to specific business requirements and industry needs."
    },
    {
      question: "What industries does AediaX serve?",
      answer: "We serve education, healthcare, finance, e-commerce, manufacturing, and various other industries with custom software solutions."
    },
    {
      question: "How does AediaX approach AI development?",
      answer: "We use a combination of machine learning, deep learning, and modern AI frameworks to build intelligent, data-driven solutions."
    }
  ],
  
  projects: [
    {
      name: "Flavra Pogi Food System",
      description: "Meal management and food ordering system with Razorpay integration",
      technologies: ["React", "Firebase", "Razorpay", "Gemini AI"],
      year: "2025"
    },
    {
      name: "University Management System",
      description: "Comprehensive management system for educational institutions",
      technologies: ["React", "Node.js", "MongoDB"],
      status: "In Development"
    },
    {
      name: "AI Chatbot Platform",
      description: "Customizable AI chatbot solution for businesses",
      technologies: ["Gemini AI", "React", "Firebase"],
      status: "Available"
    }
  ],
  
  team: [
    {
      name: "Amresh Bhuyan",
      role: "Founder & Director",
      expertise: "AI/ML, Full Stack Development, Business Strategy",
      email: "amresh@aediax.com"
    },
    {
      name: "Sanat Kumar Bhuyan",
      role: "Director",
      expertise: "Business Operations, Strategic Planning",
      email: "sanat@aediax.com"
    }
    // Add more team members as they join
  ],
  
  businessHours: {
    weekdays: "9:00 AM - 6:00 PM IST",
    saturday: "10:00 AM - 4:00 PM IST",
    sunday: "Closed",
    emergency: "24/7 support for existing clients"
  },
  
  certifications: [
    "MCA Registered Company",
    "ISO 9001:2025 (In Process)",
    "Startup India Recognition (Applied)"
  ],
  
  partners: [
    {
      name: "Google Cloud Partner",
      status: "In Progress"
    },
    {
      name: "Razorpay Partner",
      status: "Active"
    }
  ],
  
  achievements: [
    "Successfully deployed AI-powered solutions for 10+ businesses",
    "Recognized as emerging AI startup in Odisha",
    "Building India's first AI-based Signature Verification System"
  ]
};

export default companyData;